import { isArray } from "lodash";
import { DEFAULT_WORK_TYPE_COLOR } from "@utils";

export const parseWorkTypesOrMetadata = (availableWorkTypes, workTypes, metadata) => {
  if(!metadata)
    return workTypes || [];
  
  let parsedMetadata = metadata;
  
  if(typeof parsedMetadata === "string") {
    parsedMetadata = JSON.parse(metadata);
    if(!parsedMetadata.workTypes)
      parsedMetadata.workTypes = [];
    else if(!isArray(parsedMetadata.workTypes))
      parsedMetadata.workTypes = Object.values(parsedMetadata.workTypes);
  }
  
  return parsedMetadata.workTypes
    ?.map(wT => availableWorkTypes.find(aWT => aWT.id === wT.id) || { ...wT, backgroundColor: wT.backgroundColor || DEFAULT_WORK_TYPE_COLOR })
    ?.filter(wT => wT);
}